<script setup>
import Popin from "@/containers/popin-adaptive";
import Button from "@/components/atoms/button";
import ButtonIcon from "@/components/molecules/button-icon";

const props = defineProps({
  url: {
    type: String,
    required: true
  },
  message: {
    type: String,
    required: false,
    default:
      "Pour consulter cette page vous allez être redirigé vers le site Carrefour"
  },
  cancelMessage: {
    type: String,
    required: false,
    default: "Je reste sur cora.fr"
  },
  okMessage: {
    type: String,
    required: false,
    default: "Je continue vers carrefour.fr"
  },
  component: {
    type: [Object, Function],
    required: true
  }
});
const popinRef = ref(null);
const closePopin = () => {
  popinRef?.value.hide();
};
const showPopin = () => {
  popinRef?.value.show();
};
</script>

<template>
  <component
    :is="component"
    v-bind="$attrs"
    @click="showPopin()"
  >
    <slot />
  </component>
  <Popin
    ref="popinRef"
    size="md"
  >
    <h1 class="u-font-secondary u-text-center u-color-primary u-font-24 u-font-700">
      {{ message }}
    </h1>
    <div class="u-flex u-flex-justify-between u-mt-md u-mb-md u-flex-column@sm">
      <Button
        outline
        variant="primary"
        size="md"
        radius="full"
        class="u-mb-md@sm"
        @click="closePopin()"
      >
        {{ cancelMessage }}
      </Button>
      <ButtonIcon
        variant="primary"
        size="md"
        @click="closePopin()"
        :to="url"
        radius="full"
        target="_blank"
        icon-name="external"
        icon-position="right"
        icon-color="white"
        icon-color-hover="white"
      >
        {{ okMessage }}
      </ButtonIcon>
    </div>
  </Popin>
</template>